import { Heading, Loader, Stepper } from "@/components";
import useAddEditOCP from "./useAddEditOCP";
import { steps } from "./consts";
import { Step1, Step2, Step3, Step4, Step5, Step6 } from "./Steps";
import { Card, CardContent } from "@/components/ui";
import { Info } from "lucide-react";

const AddEditOCP = () => {
  const {breadcrumbData, activeStep, onStepperClick, isView,
    onCancel, onSubmit, isAddPending, title, isLoadingPacketData, isBillPending
  } = useAddEditOCP();

  return (
    <div className="p-4 md:p-6">
      <div className="mb-6 grid grid-cols-1 lg:grid-cols-10">
        <div className="lg:col-span-3">
          <Heading
            title={title}
            breadcrumbData={breadcrumbData}
          />
        </div>
        <div className="w-full mb-6 lg:col-span-7 flex justify-end">
          <Stepper
            steps={steps}
            currentStep={activeStep}
            onStepperClick={onStepperClick}
          />
        </div>
      </div>

      {isLoadingPacketData ? <Loader /> : 
        <>
          {isBillPending ? <Card className="shadow-none rounded-lg border-0 bg-red-50 border border-red-200 p-0 mb-5">
            <CardContent className="text-red-600 text-[14px] p-3 flex flex-row gap-2 items-center">
              <Info className="h-5 w-5"/> 
              <span>User has pending bills. Please resolve them before creating an OCP.</span>
            </CardContent>
          </Card> : <></>}
          {activeStep === 1 && (
            <Step1
              onCancel={onCancel}
              onSubmit={onSubmit}
              isView={isView}
              isAddPending={isAddPending}
            />
          )}
          {activeStep === 2 && 
            <Step2 
              onCancel={onCancel}
              onSubmit={onSubmit}
              isView={isView}
              isAddPending={isAddPending}
            />
          }
          {activeStep === 3 && 
            <Step3
              onCancel={onCancel}
              onSubmit={onSubmit}
              isView={isView}
              isAddPending={isAddPending}
            />
          }
          {activeStep === 4 && 
            <Step4
              onCancel={onCancel}
              onSubmit={onSubmit}
              isAddPending={isAddPending}
              isView={isView} 
            />
          }
          {activeStep === 5 && 
            <Step5
              onCancel={onCancel}
              onSubmit={onSubmit}
              isAddPending={isAddPending}
              isView={isView} 
            />
          }
          {activeStep === 6 && 
            <Step6 />
          }
        </>
      }
    </div>
  )
}

export default AddEditOCP;